import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UploadFileDialogComponent } from 'shared/dialogs/upload-file-dialog/upload-file-dialog.component';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { UploadFileButtonComponent } from 'shared/modules/controls/upload-file-button/upload-file-button.component';
import { MaterialModule } from 'shared/modules/material/material.module';

@NgModule({
  declarations: [
    UploadFileDialogComponent,
    UploadFileButtonComponent,
  ],
  imports: [
    TranslateModule,
    MaterialModule,
    AngularModule,
  ],
  exports: [
    UploadFileButtonComponent,
    UploadFileDialogComponent,
  ],
})
export class UploadFileButtonModule {
}
